// extracted by mini-css-extract-plugin
export default {"modalContent":"style_modalContent__zdI0w","title":"style_title__8+Ooz","description":"style_description__ajLDs","actionIcon":"style_actionIcon__-NUe0"};